import { customAgencyQuestions } from './capabilities';
import sameCurrentBase from './sameCurrentBase';

const mergeCustomWithBaseSteps = ({ steps = {}, customStepsCatalog = {} }) => {
  const mergedSteps = { ...steps };

  const addStep = (stepToAddKey, stepToAddValue) => {
    Object.keys(mergedSteps).forEach(baseStepKey => {
      const baseStepValue = mergedSteps[baseStepKey];

      if (
        stepToAddValue.next === baseStepValue.next ||
        stepToAddValue.back === baseStepValue.current
      )
        if (sameCurrentBase(baseStepValue.current, stepToAddValue.current))
          baseStepValue.next = stepToAddValue.current;
      if (
        stepToAddValue.back === baseStepValue.back ||
        stepToAddValue.next === baseStepValue.current
      )
        if (sameCurrentBase(baseStepValue.current, stepToAddValue.current))
          baseStepValue.back = stepToAddValue.current;
    });
    mergedSteps[stepToAddKey] = stepToAddValue;
  };

  customAgencyQuestions.forEach(stepName => {
    const customSteps = customStepsCatalog[stepName];
    if (customSteps)
      Object.keys(customSteps).forEach(customStepKey =>
        addStep(customStepKey, customSteps[customStepKey]),
      );
  });
  return mergedSteps;
};

export default mergeCustomWithBaseSteps;
